import {
  CategoryResponse,
  getGiftCardGetCategoriesSlug,
  getGiftCardGetCategorySlug,
} from "api"
import SeoMetaData, { SeoMetadataWithImage } from "common/SeoMetaData"
import CategoriesPage from "components/Categories/CategoriesPage"
import { GetStaticPaths, GetStaticProps } from "next"

type SlugProps = {
  categoryName: string
}

type CategoryProps = {
  category: CategoryResponse
  seo: SeoMetadataWithImage
}

export const getStaticPaths: GetStaticPaths<SlugProps> = async () => {
  const { data } = await getGiftCardGetCategoriesSlug()
  const paths = data.body.map((slug) => ({
    params: {
      categoryName: slug.toString(),
    },
  }))
  return {
    paths,
    fallback: "blocking",
  }
}

export const getStaticProps: GetStaticProps<CategoryProps> = async ({
  params,
}) => {
  const category = await getGiftCardGetCategorySlug(
    encodeURIComponent(params.categoryName.toString())
  )
  if (!category.data.body) {
    return {
      notFound: true,
      revalidate: 60,
    }
  }
  const seo = {
    title: category?.data?.body?.pageTitle || "",
    description: category?.data?.body?.metaDescription || "",
    keywords: category?.data?.body?.keywords || "",
  }
  return {
    props: {
      category: category?.data?.body,
      seo: seo,
    },
    revalidate: 60,
  }
}

const category = ({ category, seo }: CategoryProps) => {
  return (
    <>
      <SeoMetaData data={seo} />
      <CategoriesPage category={category} />
    </>
  )
}

export default category
